/** Display placeholder for empty table cells in Policy & Access views. */
export function displayValueOrDash(value: unknown): string {
  if (value == null) {
    return '-';
  }
  const text = String(value).trim();
  return text ? text : '-';
}
